import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { UiFlipCard, UiFrontCard, UiBackCard, UiTemp } from './FlipCard.style';
import { useBooksResource } from 'utils';

import {
	AudioButton,
	Box,
} from 'components';

/**
 * 可翻面卡牌組件
 */

export const Side = {
	Front: 'Front',
	Back: 'Back',
};

export const FlipCard = ({ front, back, defaultSide = Side.Front, src }) => {
	const { getAudioSource } = useBooksResource();
	const [isRotate, setRotate] = useState(defaultSide === Side.Back);
	const toggle = () => {
		setRotate(!isRotate);
	};

	return (
		<UiFlipCard>
			<UiFlipCard onClick={toggle} isRotate={isRotate}>
				<UiFrontCard>
					{front}
				</UiFrontCard>
				<UiBackCard>
					{back}
					<UiTemp></UiTemp>
				</UiBackCard>
			</UiFlipCard>

			<Box display="flex" justifyContent="center" marginTop={35} marginBottom={24}>
					<AudioButton variant="primary" src={getAudioSource(src)} />
				</Box>
		</UiFlipCard>

	);
};

FlipCard.propTypes = {
	front: PropTypes.node,
	back: PropTypes.node,
	defaultSide: PropTypes.oneOf([Side.Front, Side.Back]),
};
